import { useState } from 'react';

function useLocalStorage<T>(
  key: string,
  initialValue: T
): readonly [T, (newValue: T | ((prevValue: T) => T)) => void] {
  const storedValue = localStorage.getItem(key);
  const initial = storedValue ? JSON.parse(storedValue) : initialValue;

  const [value, setValue] = useState<T>(initial);

  const setStoredValue = (newValue: T | ((prevValue: T) => T)): void => {
    if (typeof newValue === 'function') {
      setValue((prevValue: T) => {
        const updatedValue = (newValue as (prevVal: T) => T)(prevValue);
        localStorage.setItem(key, JSON.stringify(updatedValue));
        return updatedValue;
      });
    } else {
      setValue(newValue);
      localStorage.setItem(key, JSON.stringify(newValue));
    }
  };

  return [value, setStoredValue] as const;
}

export default useLocalStorage;
